export const makeNumberArray = (start: number, end: number) => {
  return [...Array<number>(end - start + 1)].map((_, i) => start + i)
}
